import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './SubscribeForm.css';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    mobileno: '',
    message: '',
    agree: false,
    zipcode: '',
  });

  // CAPTCHA generator
  const generateCaptcha = () => {
    const a = Math.floor(Math.random() * 10);
    const b = Math.floor(Math.random() * 10);
    return { question: `${a} + ${b}`, answer: a + b };
  };

  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [email, setEmail] = useState('');
  // Regex patterns
  const nameRegex = /^[a-zA-Z\s]+$/;
  const emailRegex = /^\S+@\S+\.\S+$/;
  const mobilenoRegex = /^\d{10}$/;
  const zipRegex = /^\d{6}$/;

  const validate = () => {
    const newErrors = {};

    if (!formData.fullname.trim()) {
      newErrors.fullname = 'Name is required.';
    } else if (!nameRegex.test(formData.fullname)) {
      newErrors.fullname = 'Name can only contain letters and spaces.';
    }

    if (!formData.email) {
      newErrors.email = 'Email is required.';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email message.';
    }

    if (!formData.mobileno) {
      newErrors.mobileno = 'Mobile number is required.';
    } else if (!mobilenoRegex.test(formData.mobileno)) {
      newErrors.mobileno = 'Mobile number must be 10 digits.';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required.';
    } else if (formData.message.length < 10) {
      newErrors.message = 'Message must be at least 10 characters.';
    }

    if (!formData.zipcode) {
      newErrors.zipcode = 'Zipcode is required.';
    } else if (!zipRegex.test(formData.zipcode)) {
      newErrors.zipcode = 'Zipcode must be exactly 6 digits.';
    }

    if (!formData.agree) {
      newErrors.agree = 'You must agree to continue.';
    }

    // CAPTCHA validation
    if (parseInt(captchaInput) !== captcha.answer) {
      newErrors.captcha = 'Incorrect CAPTCHA answer.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    

    setIsLoading(true);

    try {
      const response = await fetch('https://webvexo.com/contactform_web_mail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Email verification',
          text: 'An email verification was sent to your mailbox. Please check your email and click on the verification link in the email... ',
        });

        setFormData({
          fullname: '',
          email: '',
          mobileno: '',
          message: '',
          agree: false,
          zipcode: '',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Submission failed',
          text: 'Please try again later.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Network error',
        text: 'Check your connection and try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container margin-top mb-5 mt-5">
      <div className="row d-flex justify-content-center mb-5">
        <p className="text-center fw-bold fs-1 color">Contact Us</p>
        <div className="col-md-6 get-quote__right position-relative float-bob-x">

          <form onSubmit={handleSubmit} className="subscribe-form">

            {/* Name, Email, Mobile */}
            <div className="row">
              {[
                { name: 'fullname', label: 'Name' },
                { name: 'email', label: 'Email', type: 'email' },
                { name: 'mobileno', label: 'Mobile Number' },
              ].map(({ name, label, type = 'text' }) => (
                <div className="col-md-12 mb-2" key={name}>
                  <input
                    type={type}
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    className={`form-control ${errors[name] ? 'input-error' : ''}`}
                    placeholder={label}
                  />
                  {errors[name] && <small className="text-danger">{errors[name]}</small>}
                </div>
              ))}
            </div>

            {/* Message */}
            <div className="row mb-2">
              <div className="col-md-12">
                <textarea
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className={`form-control ${errors.message ? 'input-error' : ''}`}
                  placeholder="Write your Message..."
                ></textarea>
                {errors.message && <small className="text-danger">{errors.message}</small>}
              </div>
            </div>

            {/* ZIP Code */}
            <div className="row">
              <div className="col-md-12 mb-2">
                <input
                  type="text"
                  name="zipcode"
                  value={formData.zipcode}
                  onChange={handleChange}
                  className={`form-control ${errors.zipcode ? 'input-error' : ''}`}
                  placeholder="Zipcode"
                />
                {errors.zipcode && <small className="text-danger">{errors.zipcode}</small>}
              </div>
            </div>

            {/* CAPTCHA */}
            <div className="form-group mb-2">
              <label className="mb-1 fs-5 fw-bold">What is {captcha.question}?</label>
              <input
                type="text"
                value={captchaInput}
                onChange={(e) => setCaptchaInput(e.target.value)}
                className={`form-control ${errors.captcha ? 'input-error' : ''}`}
                placeholder="Enter answer"
              />
              {errors.captcha && <small className="text-danger">{errors.captcha}</small>}
            </div>

            {/* Terms */}
            <div className="form-check mb-3 mt-3">
              <input
                type="checkbox"
                name="agree"
                checked={formData.agree}
                onChange={handleChange}
                className={`form-check-input ${errors.agree ? 'input-error' : ''}`}
                id="agreeCheck"
              />
              <label className="form-check-label" htmlFor="agreeCheck">
                I have read and agree to the <a href="/terms" target="_blank">terms and conditions</a>
              </label>
              {errors.agree && <small className="text-danger d-block">{errors.agree}</small>}
            </div>

                <button type="submit" className="insuba-btn text-center w-100 p-3 fs-5 mt-3" disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Submitting...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
            {messages && (
                <p className={`mt-3 fs-5 ${isSuccess ? 'text-success' : 'text-danger'}`}>{messages}</p>
              )}
          </form>

        </div>
      </div>
    </div>
  );
};

export default ContactForm;
